import React from "react";
// @material-ui/core components

export default function AdminNavbarLinks() {
  return <div></div>;
}
